export interface TableCustomFieldValue {
  columns: string[];
  rows: string[][];
}

const DEFAULT_COLUMN_NAME = 'Coluna';

export const createDefaultTableValue = (): TableCustomFieldValue => ({
  columns: [`${DEFAULT_COLUMN_NAME} 1`],
  rows: [['']],
});

export const normalizeTableValue = (value: Partial<TableCustomFieldValue>): TableCustomFieldValue => {
  const safeColumns = Array.isArray(value.columns) && value.columns.length > 0
    ? value.columns.map((column, index) => {
        const normalized = String(column ?? '');
        return normalized.length > 0 ? normalized : `${DEFAULT_COLUMN_NAME} ${index + 1}`;
      })
    : createDefaultTableValue().columns;

  const safeRows = Array.isArray(value.rows) && value.rows.length > 0
    ? value.rows.map((row) => {
        const baseRow = Array.isArray(row) ? row : [];
        return safeColumns.map((_, colIndex) => String(baseRow[colIndex] ?? ''));
      })
    : [safeColumns.map(() => '')];

  return {
    columns: safeColumns,
    rows: safeRows,
  };
};

export const parseTableValue = (rawValue: unknown): TableCustomFieldValue => {
  if (!rawValue) {
    return createDefaultTableValue();
  }

  if (typeof rawValue === 'string') {
    try {
      const parsed = JSON.parse(rawValue);
      if (parsed && typeof parsed === 'object') {
        return normalizeTableValue(parsed as Partial<TableCustomFieldValue>);
      }
    } catch {
      return createDefaultTableValue();
    }
  }

  if (typeof rawValue === 'object') {
    return normalizeTableValue(rawValue as Partial<TableCustomFieldValue>);
  }

  return createDefaultTableValue();
};

export const hasTableContent = (rawValue: unknown): boolean => {
  const parsed = parseTableValue(rawValue);
  return parsed.rows.some((row) => row.some((cell) => String(cell ?? '').trim() !== ''));
};

export const serializeTableValue = (rawValue: unknown): string => {
  return JSON.stringify(parseTableValue(rawValue));
};
